import {
	initCustomSelect,
	initDateInput,
	initPassportNumberInput,
	initPassportSeriesInput,
	removeError,
	validatePassportSeriesValue,
	validatePassportNumberValue,
	addError, scrollToFirstError
} from '../lib/forms';

let orderForm,
	passportSeriesInput,
	passportNumberInput;

function init() {

	orderForm = document.querySelector('.js-order-form');

	$(document).on('submit', '.js-order-form', function() {
		let $this = $(this);
		$this.find('.form-errors').html('').hide();

		let hasError = false;

		if (passportSeriesInput && passportSeriesInput.mask) {
			removeError(passportSeriesInput);

			if (!validatePassportSeriesValue(passportSeriesInput)) {
				addError(passportSeriesInput);
				hasError = true;
			}
		}

		if (passportNumberInput && passportNumberInput.mask) {
			removeError(passportNumberInput);

			if (!validatePassportNumberValue(passportNumberInput)) {
				addError(passportNumberInput);
				hasError = true;
			}
		}

		if (hasError) {
			scrollToFirstError($this.get(0));
			return false;
		}

		BX.ajax.runComponentAction('2quick:tqOrderSef',
			'saveOrder', { // Вызывается без постфикса Action
				mode: 'class',
				data: new FormData($this[0]), // ключи объекта data соответствуют параметрам метода
			})
			.then(function(response) {
				if (response.data.status == 'success')
				{
					location.href = response.data.url;
				}
				else
				{
					$this.find('.form-errors').html(response.data.errors).show();
				}
			});

		return false;
	})

	$(document).on('submit', '.js-sign-form', function() {
		let $this = $(this);
		$this.find('.form-errors').html('').hide();
		BX.ajax.runComponentAction('2quick:tqOrderSef',
			'signToOffice', { // Вызывается без постфикса Action
				mode: 'class',
				data: new FormData($this[0]), // ключи объекта data соответствуют параметрам метода
			})
			.then(function(response) {
				if (response.data.status == 'success')
				{
					$this.remove();
					$('.profile__registration-success').show();
				}
				else
				{
					$this.find('.form-errors').html(response.data.errors).show();
				}
			});
		return false
	})

	$(document).on('change', '.js-choose-date', function() {
		let timeBlock = $('.form__fieldset--time'),
			date = $(this).val();
		timeBlock.addClass('form__fieldset--shown');
		timeBlock.find('[data-date]').hide();
		timeBlock.find('[data-date] input').attr('disabled', true);
		timeBlock.find('[data-date="' + date + '"]').show();
		timeBlock.find('[data-date="' + date + '"] input').attr('disabled', false);
		showLastStepForm()
	})

	$(document).on('change', '.js-choose-time', function() {
		showLastStepForm()
	})

	$(document).on('click', '.add-child', function() {
		let section = $('.form__section .child-section:last').clone();
		let num = parseInt(section.attr('id').replace(/\D/g, '')) + 1;

		section.find('.form__input').each(function() {
			let name = $(this).prop('name').replace(/\d/g, num);
			$(this).prop('name', name);
		});

		section.attr('id', 'child-section-' + num);

		let sectionElem = section.get(0);

		let profilesSelectCopy = sectionElem.querySelector('.js-choose-profile');
		if (profilesSelectCopy && window.childrenProfilesList) {

			let profileSelectHtml = `<select class="form__select js-select js-choose-profile" name="profile-choose">
				<option value="" selected>Не заполнять</option>`;

			for (let profile of window.childrenProfilesList) {
				profileSelectHtml += `<option value="${profile.ID}">${profile.FIELDS['profile-lastname']} ${profile.FIELDS['profile-name']} ${profile.FIELDS['profile-surname']}</option>`
			}

			profileSelectHtml += `</select>`;

			let fieldBlock = profilesSelectCopy.closest('.form__field');
			if (fieldBlock) {
				fieldBlock.querySelector('.choices').remove();
				fieldBlock.insertAdjacentHTML('beforeend', profileSelectHtml);
			}
		}

		let genderSelectCopy = sectionElem.querySelector('.js-choose-gender');
		if (genderSelectCopy) {

			let genderSelectHtml = `
				<select class="form__select js-select js-choose-gender" name="CHILD[${num}][GENDER_CHILD]" required>
					<option value="" selected>Выберите пол</option>
					<option value="Мужской">Мужской</option>
					<option value="Женский">Женский</option>
				</select>`;

			let fieldBlock = genderSelectCopy.closest('.form__field');
			if (fieldBlock) {
				fieldBlock.querySelector('.choices').remove();
				fieldBlock.insertAdjacentHTML('beforeend', genderSelectHtml);
			}
		}

		$('.form__section .child-section:last').after(section);


		sectionElem.querySelectorAll(".js-date-mask")
			.forEach(initDateInput);

		sectionElem.querySelectorAll(".js-select")
			.forEach(initCustomSelect);

		updateChildSectionFields(sectionElem, '');
	})

	$(document).on('click', '.remove-child', function() {
		$(this).parents('.child-section').remove();
	});

	function showLastStepForm() {
		let form = $('.js-sign-form');
		if (form.find('input[name=DATE]:enabled:checked').length)
		{
			form.find('.form__bottom').addClass('form__bottom--shown');
			form.find('.form__fieldset--contacts').addClass('form__fieldset--shown');
		}
		else
		{
			form.find('.form__bottom').removeClass('form__bottom--shown');
			form.find('.form__fieldset--contacts').removeClass('form__fieldset--shown');
		}
	}

	if (orderForm) {
		orderForm.addEventListener('change', (e) => {
			let target = e.target;

			if (target.classList.contains('js-choose-profile')) {
				let childSection = target.closest('.child-section');
				if (childSection) {
					updateChildSectionFields(childSection, target.value);
				}
			}
		});

		passportSeriesInput = orderForm.querySelector('#parent-profile-passport-series');
		if (passportSeriesInput) {
			initPassportSeriesInput(passportSeriesInput);

			if (passportSeriesInput.mask) {
				passportSeriesInput.mask.on('accept', function() {
					if (validatePassportSeriesValue(passportSeriesInput)) {
						removeError(passportSeriesInput);
					}
				});
			}
		}

		passportNumberInput = orderForm.querySelector('#parent-profile-passport-number');
		if (passportNumberInput) {
			initPassportNumberInput(passportNumberInput);

			if (passportNumberInput.mask) {
				passportNumberInput.mask.on('accept', function() {
					if (validatePassportNumberValue(passportNumberInput)) {
						removeError(passportNumberInput);
					}
				});
			}
		}
	}

	function updateChildSectionFields(childSection, profileID) {
		let fieldsMap = {
			'profile-lastname': 'CHILD_LAST_NAME',
			'profile-name': 'CHILD_NAME',
			'profile-surname': 'CHILD_MIDDLE_NAME',
			'profile-gender': 'GENDER_CHILD',
			'profile-birthday': 'CHILD_DATE_OF_BIRTH',
			'profile-school': 'CHILD_SCHOOL',
			'profile-grade': 'CHILD_CLASS',
			'profile-school-address': 'CHILD_ADDRESS',
		};

		let profileFields = {};

		if (profileID !== '' && window.childrenProfilesList) {
			for (let profile of window.childrenProfilesList) {
				if (profile.ID === profileID)
					profileFields = profile.FIELDS;
			}
		}

		let [, sectionNum] = childSection.id.split('child-section-');

		for (let fieldCode in fieldsMap) {
			let fieldElement = childSection.querySelector(`[name="CHILD[${sectionNum}][${fieldsMap[fieldCode]}]"]`);
			if (!fieldElement) continue;

			let profileFieldValue = profileFields.hasOwnProperty(fieldCode) ? profileFields[fieldCode] : '';

			if (fieldCode === 'profile-gender' && fieldElement.customSelect) {
				let choiceValue = '';

				if (profileFieldValue === 'male')
					choiceValue = 'Мужской';
				else if (profileFieldValue === 'female')
					choiceValue = 'Женский';

				fieldElement.customSelect.setChoiceByValue(choiceValue);
			}
			else if (fieldCode === 'profile-birthday' && fieldElement.dateMask) {
				fieldElement.dateMask.value = profileFieldValue;
			}
			else {
				fieldElement.value = BX.util.htmlspecialcharsback(profileFieldValue);
			}
		}
	}
}

export default {
	init // запуск в local/components/2quick/tqOrderSef/templates/.default/script.js
};